import API from '../api';

export default class ChallengeService {
  constructor() {
    this.API = new API();
  }

  // challenges are loaded from contests while other types are tests
  getAllItems = (type) => this.API.get(type === 'challenges' ? '/contest/' : `/test/${type}`);

  // challenges are loaded from contests while other types are tests
  getItem = (id, type) => this.API.get(type === 'challenges' ? `/contest/${id}` : `/test/${type}/${id}`);

  setItemRating = (rating, testId) => this.API.post(`/testRating/${testId}`, { rating });

  getTournamentPlayback = (data) =>
    this.API.get(`/tournamentMatch/getTournamentPlayback/${data.contest}/${data.account}/${data.limit}`);

  getHackathonMatches = (contestId) => this.API.get(`/tournamentMatch/getHackathonMatches/${contestId}`);

  getContestRedirectPath = (shortPath) => this.API.get(`/contest/redirect/${shortPath}`);

  getContestsForCMS = (id) => this.API.get(`/contest/cmsContests/${id}`);

  createContest = (id) => this.API.post(`/contest/${id}`);

  deleteContest = (id) => this.API.delete(`/contest/${id}`);
}
